import { LitElement } from "lit";

import { property, state } from "lit/decorators.js";

export abstract class FormElement extends LitElement {
  static formAssociated = true;

  static override shadowRootOptions: ShadowRootInit = {
    ...LitElement.shadowRootOptions,
    delegatesFocus: true,
  };

  declare protected _internals: ElementInternals;
  protected _value: string | File | FormData = "";

  @property({ type: String }) name = "";
  @property({ type: String }) customError = "";

  @state() protected focused = false;
  @state() protected hasError = false;
  @state() protected errorMessage = "";

  constructor() {
    super();
    this._internals = this.attachInternals();
  }

  override connectedCallback() {
    super.connectedCallback();
    this._internals.setFormValue(this._value);
  }

  @property({ type: String })
  get value(): string {
    return this._value as string;
  }

  set value(newValue: string) {
    this._value = newValue;
    this._internals.setFormValue(newValue);
  }

  get form(): HTMLFormElement | null {
    return this._internals.form;
  }

  get validity(): ValidityState {
    return this._internals.validity;
  }

  get validationMessage(): string {
    return this._internals.validationMessage;
  }

  checkValidity(): boolean {
    return this._internals.checkValidity();
  }

  reportValidity(): boolean {
    return this._internals.reportValidity();
  }

  setCustomValidity(message: string): void {
    this.customError = message;
    this._internals.setValidity(message ? { customError: true } : {}, message);
    this.hasError = !!message;
    this.errorMessage = message;
  }

  formResetCallback(): void {
    this.value = "";
    this.hasError = false;
    this.errorMessage = "";
    this.setCustomValidity("");
  }

  formStateRestoreCallback(state: string): void {
    this.value = state;
  }
}
